angular
.module('inputNdg.components', [])
.component('inputNdg', {
	templateUrl: 'ng/components/inputNdg/inputNdg.html',
	bindings: {
		/** Input data **/
		inputId: '@',
		inputName: '@',
		inputClass: '@',
		formName: '=',
		bindingVariable: '=',
		/** Optional data **/
		inputDisableOn: '<',
		inputRequired: '<',
		inputTabindex: "@"
	},
	controllerAs: 'inputNdgCtrl',
	controller: function($scope, $translate, validationService) {

		/** not to loose *this reference **/
		var self = this;

		self.validationService = validationService;	

		self.$onInit = function () {
			console.log(self);
			self.inputDisableOn = self.inputDisableOn || false;

			//Quando viene costruito, check immediato sulla validità
			self.bindingVariable && self.checkNdg(self.bindingVariable);
		}

		self.$onChanges = function(changesObj){
			//console.log('input-ndg $onChanges!', changesObj);
		}
		
		self.$doCheck = function(){
			//console.log('input-ndg $doCheck!', self);
		}

		self.$postLink = function(){
			//console.log('input-ndg $postLink!', self);
		}

		self.$onDestroy = function(){
			//console.log('input-ndg $onDestroy!', self);
		}

		self.errorMsgShown = false;

		self.resetAlert = function(){
			self.errorMsgShown = false;
		}

		self.showAlertMsg = function(){
			self.errorMsgShown = !self.errorMsgShown;
		}

		self.checkNdg = function(ndg) {
			if(typeof(ndg) == 'undefined'){
				self.formName[self.inputName] &&
					self.formName[self.inputName].$setValidity('ndg', false);
				self.valid = false;
				return;
			}

			if (ndg == '') {
				if(self.inputRequired){
					self.formName[self.inputName].$setValidity('ndg', false);
					self.valid = false;
					return;
				} else {
					self.formName[self.inputName].$setValidity('ndg', true);
					self.valid = true;
					return;
				}
			}

			if (!validationService.isValidNdg(ndg)){
				self.formName[self.inputName].$setValidity('ndg', false);
				self.valid = false;
				return;
			}

			self.formName[self.inputName] &&
				self.formName[self.inputName].$setValidity('ndg', true);
			self.valid = true;
			
		}

	}
});